export default "__VITE_ASSET__BTrlsxlU__"